/** Tabs on Delegation > Request (prod parity). */
export function getDelegationRequestTabs(userRole) {
  const tabs = [{ title: 'Landlords', key: 'landlords' }];
  if (userRole === 'rm') {
    tabs.push({ title: 'Full Portfolio', key: 'vp' });
  }
  return tabs;
}

export function canAccessDelegationRequest(userRole) {
  return userRole === 'vp';
}
